import DynamicBreadCrumbs from "./DynamicBreadCrumbs";
import compose from "recompose/compose";
import lifecycle from "recompose/lifecycle";
import when from "recompose/branch";
import renderNothing from "recompose/renderNothing";
import withState from "recompose/withState";
import withHandlers from "recompose/withHandlers";
import mapProps from "recompose/mapProps";
import withQueryParams from "../../hocs/withQueryParams";
import withProductCustomisation from "../../hocs/withProductCustomisation";
import withGlobalContent from "../../hocs/withGlobalContent";
import withMedia from "../../hocs/withMediaQueries";
import { withFormik } from "formik";
import get from "lodash/get";
import isEqual from "lodash/isEqual";

const enhance = compose(
  withState("activeNav", "setActiveNav", null),
  when(
    (props) => props.items.length === 0,
    renderNothing,
    (c) => c
  ),
  withProductCustomisation,
  withFormik({
    enableReinitialize: true,
    mapPropsToValues: (props) => ({
      character_selection:
        props.productCustomisation.character_selection ||
        props.items.map((item) => ({
          letter: item.letter,
          character: item.id, // we take the id which is not translated
          bookmark: item.bookmark,
        })),
    }),
  }),
  withQueryParams,
  withHandlers({
    handleChangeCharacter: (props) => (characterIndex, letter, character) => {
      // TODO have abastracted most of the naming to be options but there are stil
      // some 'character' related options from LMN.  To solve these providing a key
      // in prismic to what the values are.  For now there aren't any books planned with
      // the option to change the characters/options so we wont abstract this part until
      // necessary.
      const characterSelection = props.values.character_selection
        .map((selection, index) =>
          index === characterIndex ? { ...selection, character } : selection
        )
        .map((selection) => ({
          letter: selection.letter,
          character: selection.character,
        }));

      props.setFieldValue("character_selection", characterSelection);
      props.updateQueryParams({ character_selection: characterSelection });
      props.updateProductCustomisation({
        character_selection: characterSelection,
      });
      props.setActiveNav(null);
    },
  }),
  withMedia,
  withGlobalContent,
  mapProps(({ globalContent, ...props }) => {
    const canvasContent = get(globalContent, "canvas.body", []);
    const characterPickerContent =
      canvasContent.find((item) => item.sliceType === "character_picker") || {};

    return {
      ...props,
      prismicContent: characterPickerContent.primary || {
        selectDescription: "Choose another character for %{letter}",
        cancelCta: "Cancel",
        changeCta: "Change",
        selectCta: "Select",
        selectInUse: "In use",
      },
    };
  }),
  lifecycle({
    componentDidUpdate(prevProps) {
      if (
        prevProps.productCustomisation.name !==
          this.props.productCustomisation.name ||
        prevProps.productCustomisation.locale !==
          this.props.productCustomisation.locale ||
        !isEqual(
          prevProps.items.map((item) => item.availableOptions.letter),
          this.props.items.map((item) => item.availableOptions.letter)
        )
      ) {
        this.props.removeQueryParams("character_selection");
        this.props.updateProductCustomisation({ character_selection: null });
        this.props.resetForm();
      }
    },
  })
);

export default enhance(DynamicBreadCrumbs);
